import { render } from "./bh-button-v1.vue?vue&type=template&id=7b32620e&scoped=true"
import script from "./bh-button-v1.vue?vue&type=script&lang=js"
export * from "./bh-button-v1.vue?vue&type=script&lang=js"

import "./bh-button-v1.vue?vue&type=style&index=0&id=7b32620e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b32620e"]])

export default __exports__